import React from 'react';
import { connect } from 'react-redux';
import ControlsComponent from '../../../components/Controls/Controls';
import {getAllOffers} from "../../../redux/actions/offers";

class Controls extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }
  getVal() {
    const { offers, id } = this.props;
    let result = { prev: null, next: null },
      currentIndex;
    if (offers && offers.length > 1) {
      currentIndex = offers.findIndex(item => item.id === id);
      result.prev = currentIndex - 1 >= 0 ? offers[currentIndex - 1] : null;
      result.next =
        currentIndex + 1 <= offers.length ? offers[currentIndex + 1] : null;
    }
    return result;
  }

  componentDidMount() {
    const { offers } = this.props;
    if (!offers) {
      this.props.getAllOffers();
    }
  }

  render() {
    const val = this.getVal();
    return <ControlsComponent prev={val.prev} next={val.next} />;
  }
}

export default connect(
  state => ({
    offers: state.Executorship.Offers.offers.allOffers,
    isLoading: state.Executorship.Offers.offers.offersLoading,
  }),
  {
    getAllOffers,
  }
)(Controls);
